
define('jst!address_book_export/_matrix',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<ul class="matrix">\n<% _.each(providers, function(provider) { %>\n  <li class="<%=className%>" data-id="<%=provider[idProperty]%>">\n    <div class="icon-32 icon-32-<%=provider.icon%>"></div>\n    <div class="name"><%=provider.label%></div>\n  </li>\n<% }); %>\n</ul>\n');
 });

